import React, { useEffect, useRef, createElement } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ClockIcon, ZapIcon } from 'lucide-react';
export function WebsiteDemoLP4() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  useEffect(() => {
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.body.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/1n3dmu6l5z.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.body.appendChild(embedScript);
    return () => {
      if (document.body.contains(playerScript)) document.body.removeChild(playerScript);
      if (document.body.contains(embedScript)) document.body.removeChild(embedScript);
    };
  }, []);
  return <section ref={ref} className="w-full py-20 px-4 bg-navy" data-id="element-744">
      <div className="max-w-4xl mx-auto" data-id="element-745">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 50
      }} transition={{
        duration: 0.8
      }} className="text-center mb-10" data-id="element-746">
          <div className="inline-flex items-center gap-2 bg-gold/10 border border-gold/30 rounded-full px-4 py-1.5 mb-6" data-id="element-747">
            <ClockIcon className="h-4 w-4 text-gold" data-id="element-748" />
            <span className="font-heading font-bold text-xs text-gold uppercase tracking-wider" data-id="element-749">
              Construido en menos de 1 hora
            </span>
          </div>

          <h2 className="font-heading font-black text-3xl md:text-4xl lg:text-5xl mb-4" data-id="element-750">
            Mira un Sitio Web Real{' '}
            <span className="text-gold" data-id="element-751">Creado con el Sistema</span>
          </h2>
          <p className="font-body text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-752">
            Este sitio fue construido desde cero usando nuestros cerebros de IA.
            Sin código. Sin diseño. Listo para presentar al cliente.
          </p>
        </motion.div>

        {/* Phone mockup with vertical video */}
        <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        y: 0,
        scale: 1
      } : {
        opacity: 0,
        y: 40,
        scale: 0.95
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex justify-center" data-id="element-753">
          <div className="relative w-[280px] sm:w-[320px] md:w-[360px]" data-id="element-754">
            {/* Phone frame */}
            <div className="relative bg-black rounded-[2.5rem] p-3 shadow-2xl border border-gray-700/50" style={{
            boxShadow: '0 25px 60px rgba(0,0,0,0.5), 0 0 40px rgba(212,175,55,0.1)'
          }} data-id="element-755">
              {/* Notch */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-28 h-6 bg-black rounded-b-2xl z-10" data-id="element-756" />

              {/* Screen */}
              <div className="rounded-[2rem] overflow-hidden bg-navy-dark" data-id="element-757">
                <div dangerouslySetInnerHTML={{
                __html: "<style>{`wistia-player[media-id='1n3dmu6l5z']:not(:defined){background:center/contain no-repeat url('https://fast.wistia.com/embed/medias/1n3dmu6l5z/swatch');display:block;filter:blur(5px);padding-top:177.78%}`}</style><wistia-player media-id='1n3dmu6l5z' aspect='0.5625'></wistia-player>"
              }} data-id="element-758" />
              </div>

              {/* Home indicator */}
              <div className="flex justify-center pt-2" data-id="element-759">
                <div className="w-24 h-1 bg-gray-600 rounded-full" data-id="element-760" />
              </div>
            </div>

            {/* Glow effect behind phone */}
            <div className="absolute inset-0 -z-10 bg-gold/10 blur-3xl rounded-full scale-75" data-id="element-761" />
          </div>
        </motion.div>

        {/* Stats below */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-10" data-id="element-762">
          <div className="flex items-center gap-2" data-id="element-763">
            <ZapIcon className="h-5 w-5 text-gold" data-id="element-764" />
            <span className="font-body text-sm text-gray-300" data-id="element-765">Sin código</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-766">
            <ClockIcon className="h-5 w-5 text-gold" data-id="element-767" />
            <span className="font-body text-sm text-gray-300" data-id="element-768">
              Menos de 1 hora
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-769">
            <div className="w-5 h-5 rounded-full bg-green-500/20 flex items-center justify-center" data-id="element-770">
              <div className="w-2.5 h-2.5 rounded-full bg-green-500" data-id="element-771" />
            </div>
            <span className="font-body text-sm text-gray-300" data-id="element-772">
              Listo para vender
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}